import { Link } from 'react-router-dom';

const Logo = ({ color = "black", showText = true, size = "default" }) => {
  const sizeClasses = {
    default: "w-10 h-10",
    small: "w-8 h-8",
    large: "w-14 h-14",
  };

  return (
    <Link to="/" className="flex items-center space-x-2">
      <img
        src="/assets/images/logo.png"
        alt="Ancile AI Logo"
        className={`${sizeClasses[size]} object-contain`}
      />
      {showText && (
        <span className={`font-bold text-xl font-roboto text-${color}`}>Ancile</span>
      )}
    </Link>
  );
};

export default Logo; 